import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestCommissionByFinancialRequest } from './CommissionByFinancial.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportCommissionByFinancial(
  params: QuestCommissionByFinancialRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/CommissionByFinancial`,
    params,
  )) as unknown;

  return result as BlobPart;
}
